import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "How much does it cost to develop a mobile phone app in Indianapolis?",
    answer: `<p>Based on recent industry findings, the expense of developing a mobile app typically ranges from $30,000 to $250,000, with an average expenditure of around $171,450. However, it's important to note that these numbers are approximate and the actual cost could vary considerably depending on the specifics of the project.</p>`,
  },
  {
    question: "Is mobile app development still profitable in Indianapolis?",
    answer: `<p>Yes, mobile app development is still a profitable market in 2024. However, developers must craft top-notch applications that fulfill user requirements adeptly to achieve success.</p>`,
  },
  {
    question:
      "How do I find the best mobile app developer company in Indianapolis?",
    answer: ` <p>You can find the best mobile app development company in Indianapolis by analyzing these five quality consideration factors:</p>
    <ul>
        <li>Qualification and Experience</li>
        <li>References and Portfolio</li>
        <li>App Development Cost</li>
        <li>Communication Process</li>
        <li>Client Focus</li>
    </ul>`,
  },
  {
    question:
      "I already have an idea - How can I start my app journey with TekRevol?",
    answer: ` <p>You can seamlessly start your app development journey by partnering with TekRevol. To get started, simply fill out the form or <Link to='https://www.tekrevol.com/contact' rel='noopener' aria-label='TekRevol'>contact our live agents.</Link></p>
        <p>Our team of experts will swiftly address any inquiries you have about your application. After that, our experienced professionals will carefully attend to your queries and issues to provide effective solutions in a timely manner.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
